import { render, staticRenderFns } from "./TodayCard.vue?vue&type=template&id=71335d7b"
import script from "./TodayCard.vue?vue&type=script&lang=js"
export * from "./TodayCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports